// Author Lin
// Date 2021-11-20 15:28:29

class MintalMesPrdSmeltingElectrodeDischargePlan {
        constructor({
                id = null,
                recordTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                pressingLengthOne = '',
                pressingLengthTwo = '',
                pressingLengthThree = '',
                weightOne = '',
                weightTwo = '',
                weightThree = '',
                weightDiffOne = '',
                weightDiffTwo = '',
                weightDiffThree = '',
                currentOne = '',
                currentTwo = '',
                currentThree = '',
                secondCurrentOne = '',
                secondCurrentTwo = '',
                secondCurrentThree = '',
                resistanceOne = '',
                resistanceTwo = '',
                resistanceThree = '',
                meltAmountOne = '',
                meltAmountTwo = '',
                meltAmountThree = '',
                electrodePositionOne = '',
                electrodePositionTwo = '',
                electrodePositionThree = '',
                heaterTempOne = '',
                heaterTempTwo = '',
                heaterTempThree = '',
                furnacePower = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.recordTime = recordTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.pressingLengthOne = pressingLengthOne;
            this.pressingLengthTwo = pressingLengthTwo;
            this.pressingLengthThree = pressingLengthThree;
            this.weightOne = weightOne;
            this.weightTwo = weightTwo;
            this.weightThree = weightThree;
            this.weightDiffOne = weightDiffOne;
            this.weightDiffTwo = weightDiffTwo;
            this.weightDiffThree = weightDiffThree;
            this.currentOne = currentOne;
            this.currentTwo = currentTwo;
            this.currentThree = currentThree;
            this.secondCurrentOne = secondCurrentOne;
            this.secondCurrentTwo = secondCurrentTwo;
            this.secondCurrentThree = secondCurrentThree;
            this.resistanceOne = resistanceOne;
            this.resistanceTwo = resistanceTwo;
            this.resistanceThree = resistanceThree;
            this.meltAmountOne = meltAmountOne;
            this.meltAmountTwo = meltAmountTwo;
            this.meltAmountThree = meltAmountThree;
            this.electrodePositionOne = electrodePositionOne;
            this.electrodePositionTwo = electrodePositionTwo;
            this.electrodePositionThree = electrodePositionThree;
            this.heaterTempOne = heaterTempOne;
            this.heaterTempTwo = heaterTempTwo;
            this.heaterTempThree = heaterTempThree;
            this.furnacePower = furnacePower;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingElectrodeDischargePlan();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pressingLengthOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.pressingLengthOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pressingLengthTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.pressingLengthTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pressingLengthThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.pressingLengthThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'weightOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.weightOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'weightTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.weightTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'weightThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.weightThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'weightDiffOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.weightDiffOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'weightDiffTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.weightDiffTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'weightDiffThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.weightDiffThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'currentOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.currentOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'currentTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.currentTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'currentThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.currentThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondCurrentOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.secondCurrentOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondCurrentTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.secondCurrentTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondCurrentThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.secondCurrentThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'resistanceOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.resistanceOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'resistanceTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.resistanceTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'resistanceThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.resistanceThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'meltAmountOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.meltAmountOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'meltAmountTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.meltAmountTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'meltAmountThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.meltAmountThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodePositionOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.electrodePositionOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodePositionTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.electrodePositionTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodePositionThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.electrodePositionThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heaterTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.heaterTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heaterTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.heaterTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heaterTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.heaterTempThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnacePower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.furnacePower',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            pressingLengthOneFilter : '',
            pressingLengthTwoFilter : '',
            pressingLengthThreeFilter : '',
            weightOneFilter : '',
            weightTwoFilter : '',
            weightThreeFilter : '',
            weightDiffOneFilter : '',
            weightDiffTwoFilter : '',
            weightDiffThreeFilter : '',
            currentOneFilter : '',
            currentTwoFilter : '',
            currentThreeFilter : '',
            secondCurrentOneFilter : '',
            secondCurrentTwoFilter : '',
            secondCurrentThreeFilter : '',
            resistanceOneFilter : '',
            resistanceTwoFilter : '',
            resistanceThreeFilter : '',
            meltAmountOneFilter : '',
            meltAmountTwoFilter : '',
            meltAmountThreeFilter : '',
            electrodePositionOneFilter : '',
            electrodePositionTwoFilter : '',
            electrodePositionThreeFilter : '',
            heaterTempOneFilter : '',
            heaterTempTwoFilter : '',
            heaterTempThreeFilter : '',
            furnacePowerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'pressingLengthOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.pressingLengthOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pressingLengthTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.pressingLengthTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pressingLengthThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.pressingLengthThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'weightOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.weightOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'weightTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.weightTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'weightThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.weightThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'weightDiffOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.weightDiffOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'weightDiffTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.weightDiffTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'weightDiffThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.weightDiffThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'currentOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.currentOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'currentTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.currentTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'currentThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.currentThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondCurrentOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.secondCurrentOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondCurrentTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.secondCurrentTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondCurrentThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.secondCurrentThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'resistanceOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.resistanceOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'resistanceTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.resistanceTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'resistanceThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.resistanceThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'meltAmountOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.meltAmountOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'meltAmountTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.meltAmountTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'meltAmountThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.meltAmountThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodePositionOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.electrodePositionOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodePositionTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.electrodePositionTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodePositionThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.electrodePositionThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heaterTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.heaterTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heaterTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.heaterTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heaterTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.heaterTempThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'furnacePower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.furnacePower',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischargePlan.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingElectrodeDischargePlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        